<template>
  <div>
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title">{{ $t("view") }} {{ $tc("cinema", 2) }}</div>
      <div>
        <div
          v-if="$can('update', 'Cinemas')"
          class="btn-blue"
          @click="$router.push(`/cinema-manager/edit-cinema?id=${cinema_id}`)"
        >
          {{ $t("edit") }}
        </div>
        <router-link class="btn-blue" to="cinemas"
          >{{ $tc("cinema", 2) }} {{ $tc("list", 2) }}</router-link
        >
      </div>
    </div>

    <div class="all-details-container">
      <div class="col-md-12">
        <div class="row">
          <div
            v-for="(item, index) in Cinemas"
            :key="index"
            class="col-md-12 py-2"
          >
            <span v-if="login_user_role_id === 1">
              <div
                class="row border-bottom"
                v-if="item.fieldname == 'created_at'"
              >
                <div class="col-lg-3">{{ $tc(item.fieldkey, 1) }}</div>
                <div class="col-lg-9">{{ item.fieldvalue | dateparse }}</div>
              </div>
              <div
                class="row border-bottom"
                v-if="item.fieldname == 'created_by'"
              >
                <div class="col-lg-3">{{ $tc(item.fieldkey, 1) }}</div>
                <div class="col-lg-9">{{ item.fieldvalue }}</div>
              </div>
              <div
                class="row border-bottom"
                v-if="item.fieldname == 'updated_at'"
              >
                <div class="col-lg-3">{{ $tc(item.fieldkey, 1) }}</div>
                <div class="col-lg-9">{{ item.fieldvalue | dateparse }}</div>
              </div>
              <div
                class="row border-bottom"
                v-if="item.fieldname == 'updated_by'"
              >
                <div class="col-lg-3">{{ $tc(item.fieldkey, 1) }}</div>
                <div class="col-lg-9">{{ item.fieldvalue }}</div>
              </div>
            </span>
            <div
              class="row border-bottom"
              v-if="
                item.fieldname !== 'cine_id' &&
                item.fieldname !== 'created_at' &&
                item.fieldname !== 'created_by' &&
                item.fieldname !== 'updated_by' &&
                item.fieldname !== 'updated_at' &&
                item.fieldname !== 'dept_is_active'
              "
            >
              <div class="col-lg-3">{{ $tc(item.fieldkey, 1) }}</div>
              <div class="col-lg-9">{{ item.fieldvalue }}</div>
            </div>
          </div>
          <div class="row border-bottom" v-if="foodOrderingAppQrCodeUrl">
            <div class="col-lg-3">{{ $tc("Food Ordering QR Code") }}</div>
            <div class="col-lg-9">
              <img :src="foodOrderingAppQrCodeUrl" height="200" width="200" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import MasterService from "@/services/MasterService";
  import Cinemas from "@/helper/formJSONMaster/Cinemas";
  import QRCode from "qrcode";

  export default {
    data() {
      return {
        login_user_role_id: null,
        cinema_id: null,
        foodOrderingAppQrCodeUrl: "",
        Cinemas: [
          ...Cinemas.ms_cinemas,
          {
            fieldname: "created_by",
            fieldkey: "createdby",
            fieldvalue: "123456",
            type: "text",
          },
          {
            fieldname: "created_at",
            fieldkey: "createdat",
            fieldvalue: true,
            type: "text",
          },
          {
            fieldname: "updated_by",
            fieldkey: "modifiedby",
            fieldvalue: true,
            type: "text",
          },
          {
            fieldname: "updated_at",
            fieldkey: "modifiedat",
            fieldvalue: true,
            type: "text",
          },
        ],

        Methods: Cinemas.Methods,
        submitted: false,

        // Only get data
        Cities: [],

        CitiesMethod: {
          GET: "/admin/",
          tableName: "ms_cities",
          urlKey: "cities",
        },
        States: [],
        StatesMethod: {
          GET: "/admin/",
          tableName: "ms_states",
          urlKey: "states",
        },
      };
    },
    methods: {
      goToRoute(path) {
        this.$router.push({
          path: path,
          query: {
            id: this.tableId,
          },
        });
      },
      getCinemaDetails(id) {
        let body = this.getRequestBody("GET", undefined, {
          ...this.Methods,
          params: { id },
        });

        MasterService.GlobalRequest(body)
          .then((response) => {
            const { data } = response;
            if (data.status) {
              let obj = data.details[0];
              this.Cinemas.map((x, index) => {
                if (x.fieldname === "created_by") {
                  this.getViewUsersDetails(obj[x.fieldname], index, "Cinemas");
                } else if (x.fieldname === "updated_by") {
                  this.getViewUsersDetails(obj[x.fieldname], index, "Cinemas");
                } else if (x.type === "radio") {
                  x.fieldvalue = obj[x.fieldname] === "Y" ? "Yes" : "No";
                } else if (x.type === "date") {
                  x.fieldvalue = this._formatDate_dd_mm_yyyy(obj[x.fieldname]);
                } else if (x.type === "dropdown") {
                  x.fieldvalue = obj[x.fieldname];
                } else {
                  x.fieldvalue = obj[x.fieldname];
                }
              });
              this.getOrgList(obj.org_id);
              this.getCurrencyList(obj.currency_id);
              this.getCountryList(obj.country_id);
              this.getStatesList(obj.country_id, obj.state_id);
              this.getCitiesList(obj.state_id, obj.city_id);
              this.setFoodOrderingQrCode();
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError);
      },
      setFoodOrderingQrCode() {
        try {
          let FoodOrderingAppUrl = "";

          const globalOptionsArr = this.$store.getters.getGlobalOptions;

          for (let i = 0; i < globalOptionsArr.length; i++) {
            const globalOption = globalOptionsArr[i];

            if (globalOption.go_key === "FOOD_ORDERING_APP_URL") {
              FoodOrderingAppUrl = globalOption.go_value;
            }
          }

          if (!FoodOrderingAppUrl) return;

          FoodOrderingAppUrl =
            FoodOrderingAppUrl + `?cinema_id=${this.cinema_id}`;

          QRCode.toDataURL(FoodOrderingAppUrl, (err, url) => {
            if (err) {
              console.log("QRCode.toDataURL", err);
              return;
            }
            this.foodOrderingAppQrCodeUrl = url;
          });
        } catch (err) {
          console.log("Error in setFoodOrderingQrCode ", err);
        }
      },
      getCountryList(uniqueId) {
        this.stateList = [];
        this.countryList = [];
        this.cityList = [];
        let payload = {
          tableName: "ms_countries",
          country_is_active: "Y",
        };
        MasterService.GetActiveList(payload)
          .then((response) => {
            const { data } = response;
            if (data.status && data.Records.length > 0) {
              this.setNestedDropdownFields(
                "country_id",
                uniqueId,
                data.Records
              );
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError);
      },
      getOrgList(uniqueId) {
        let payload = {
          tableName: "organizations",
          org_is_active: "Y",
        };
        MasterService.GetActiveList(payload)
          .then((response) => {
            const { data } = response;
            if (data.status && data.Records.length > 0) {
              this.setNestedDropdownFields("org_id", uniqueId, data.Records);
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError);
      },
      getCurrencyList(uniqueId) {
        this.currency = [];
        let payload = {
          tableName: "ms_currencies",
          curr_is_active: "Y",
        };
        MasterService.GetActiveList(payload)
          .then((response) => {
            const { data } = response;
            if (data.status && data.Records.length > 0) {
              this.setNestedDropdownFields(
                "currency_id",
                uniqueId,
                data.Records
              );
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError);
      },
      getStatesList(country_id, uniqueId) {
        let payload = {
          tableName: "ms_states",
          state_is_active: "Y",
          country_id,
        };
        MasterService.GetActiveList(payload)
          .then((response) => {
            const { data } = response;
            if (data.status && data.Records.length > 0) {
              this.setNestedDropdownFields("state_id", uniqueId, data.Records);
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError); //message
      },
      getCitiesList(state_id, uniqueId) {
        let payload = {
          tableName: "ms_cities",
          city_is_active: "Y",
          state_id,
        };
        MasterService.GetActiveList(payload)
          .then((response) => {
            const { data } = response;
            if (data.status && data.Records.length > 0) {
              this.setNestedDropdownFields("city_id", uniqueId, data.Records);
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError); //message
      },
      getViewUsersDetails(user_id, index, key) {
        this[key][index].fieldvalue = "-";
        if (user_id) {
          MasterService.GetUserInfoById({ user_id })
            .then((response) => {
              const { data } = response;
              if (data && data.status && data.Records.length > 0) {
                this[key][index].fieldvalue = data.Records[0].user_name;
              } else {
                this.$toasted.show(data.message);
              }
            })
            .catch(this._CatchError); //message
        }
      },
      setNestedDropdownFields(name, id, array) {
        let filterObj = array.filter((x) =>
          name == "currency_id" ? x["curr_id"] === id : x[name] === id
        );
        if (filterObj.length > 0) {
          this.Cinemas.map((x) => {
            if (name == "country_id" && name === x.fieldname) {
              x.fieldvalue = filterObj[0].country_name;
            } else if (name == "state_id" && name === x.fieldname) {
              x.fieldvalue = filterObj[0].state_name;
            } else if (name == "city_id" && name === x.fieldname) {
              x.fieldvalue = filterObj[0].city_name;
            } else if (name == "currency_id" && name === x.fieldname) {
              x.fieldvalue = filterObj[0].curr_code;
            } else if (name == "org_id" && name === x.fieldname) {
              x.fieldvalue = filterObj[0].org_name;
            }
          });
        }
      },
    },
    beforeMount() {
      const { id } = this.$route.query;
      if (id) {
        this.cinema_id = id;
        this.getCinemaDetails(id);
      } else {
        this.$router.go(-1);
      }
      const { role_id } = this.secureStore.get("USINFO");
      this.login_user_role_id = role_id;
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/CinemasComponents/viewCinema.vue